import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class DocumentDetail extends Component {
  state = {
    pageTitle: "Belge Detay",
    pageTitleDetail: "Belge Detay",
    pageAddLink: "belge-ekle",
    pageListLink: "belge-listele",
    breadcrumb: [{ text: "Belge", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    documentTypeName: "",
    fileName: "",
    customerName: "",
    supplierName: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/documents/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            documentTypeName: response.data.documentTypeName,
            fileName: response.data.filename,
            customerName: response.data.customerName,
            supplierName: response.data.supplierName,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  conditionOrderLabel = () => {
    if (this.state.customerName) {
      return "Müşteri";
    }
    if (this.state.supplierName) {
      return "Tedarikçi";
    } else {
      return "Firma";
    }
  };

  conditionOrder = () => {
    if (this.state.customerName) {
      return this.state.customerName;
    }
    if (this.state.supplierName) {
      return this.state.supplierName;
    } else {
      return "Firma Belgesi";
    }
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          name={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  name="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Belge Türü</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.documentTypeName
                        ? this.state.documentTypeName
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Belge Adı</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.fileName ? this.state.fileName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>{this.conditionOrderLabel()}</th>
                    <th className="colon">:</th>
                    <td colSpan="4">{this.conditionOrder()}</td>
                  </tr>

                  <tr>
                    <th>Durum</th>
                    <th className="colon">:</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <th className="colon">:</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <th className="colon">:</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <th className="colon">:</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <th className="colon">:</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default DocumentDetail;
